import { Information as InfoIcon } from "@faire/slate-icons/Information";
import type { IText } from "@faire/slate/private/shared/types";
import { DEFAULT_TOOLTIP_ZINDEX } from "@faire/slate/private/tooltip/consts";
import { TooltipContent } from "@faire/slate/private/tooltip/TooltipContent";
import { TooltipRoot } from "@faire/slate/private/tooltip/TooltipRoot";
import { TooltipTrigger } from "@faire/slate/private/tooltip/TooltipTrigger";
import React from "react";

type IProps = {
  text: IText;
  zIndex?: number;
};

export const TooltipFormLabel = ({
  text,
  zIndex = DEFAULT_TOOLTIP_ZINDEX,
}: IProps) => {
  return (
    <TooltipRoot position="top" alignment="middle" role="additional-info">
      <TooltipTrigger addInteraction>
        <span className="inline-flex">
          <InfoIcon />
        </span>
      </TooltipTrigger>
      <TooltipContent portaled zIndex={zIndex}>
        <span>{text}</span>
      </TooltipContent>
    </TooltipRoot>
  );
};
